import { render, staticRenderFns } from "./todu.vue?vue&type=template&id=a1c182e4"
import script from "./todu.vue?vue&type=script&lang=js"
export * from "./todu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports